import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { H3, Btn, Image } from "../../AbstractElements";
import { useNavigate, useLocation } from "react-router-dom";
import imgg from "../../assets/images/logo/logo.png";
import { DEVELOPERTESTING, LINKS_API } from "../../Config/Config";
import axios from "axios";

const PaymentStatusContain = () => {
  const navigate = useNavigate();
  const state = useLocation();
  console.log(state);
  console.log(state);
  const linkToRegister = async () => {
    //navigate(`${process.env.PUBLIC_URL}/paymentstatus`);
    console.log(state);
    console.log(state.state.site.paymentId);
    let typePayment = "";
    if (state.state.site.paymentId === "1") {
      typePayment = "LITE";
    } else if (state.state.site.paymentId === "2") {
      typePayment = "TIER1";
    } else if (state.state.site.paymentId === "3") {
      typePayment = "TIER2";
    } else if (state.state.site.paymentId === "5") {
      typePayment = "CORPORATE";
    }

    const paymentPayload = {
      type: typePayment,
      userId: state.state.site.id,
      promoCode: "prefilled_promo_code=welcome",
    };

    // 2. Make the POST request cleanly with Axios
    const response = await axios.post(LINKS_API, paymentPayload);

    // 3. The backend returns the final generated link inside response.data.url
    if (response.data && response.data.url) {
      window.location.href = response.data.url;
    }
    //local bill plan
    // else {
    //   window.location.href = DEVELOPERTESTING + state.state.site.id;
    // }
  };
  return (
    <Container fluid={true} className="p-0">
      <Row>
        <Col xl="12">
          <div className="login-card">
            <Card>
              <CardBody>
                <div className="login-header text-center">
                  <H3>
                    Your payment could not be completed due to a technical
                    issue. Please try again.
                  </H3>
                  <br></br>
                  <Btn
                    attrBtn={{
                      color: "primary",
                      onClick: () => linkToRegister(),
                    }}
                  >
                    Retry Payment
                  </Btn>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default PaymentStatusContain;
